import { render, staticRenderFns } from "./products-table.vue?vue&type=template&id=05fa96b8&scoped=true&"
import script from "./products-table.vue?vue&type=script&lang=js&"
export * from "./products-table.vue?vue&type=script&lang=js&"
import style0 from "./products-table.vue?vue&type=style&index=0&id=05fa96b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fa96b8",
  null
  
)

export default component.exports